import React from 'react';
import { ToastContainer } from 'react-toastify';
import './Toastify.css';

function Toastify() {
  return (
    <ToastContainer
      position="bottom-right"
      autoClose={112000}
      hideProgressBar
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="light"
    />
  );
}

export default Toastify;
